import { defineComponent } from "vue";
import Button from "../../share/button";
import Popup from "../../share/popup";

import "./freeze.less";

export default defineComponent({
  emits: ["confirm"],
  props: {
    visible: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const onConfirmClick = () => {
      emit("confirm");
    };

    return () => (
      <Popup position="center" visible={props.visible} width={320}>
        <div class="feiyu-login-freeze">
          <div class="feiyu-login-freeze--title">{"温馨提示"}</div>
          <div class="feiyu-login-freeze--content">
            {"您的游戏账号当前处于冷静期，15个工作日内将完成账号注销。如需撤销请联系客服。"}
          </div>
          <div class="feiyu-login-freeze--action">
            <Button type="primary" onClick={onConfirmClick}>
              {"确定"}
            </Button>
          </div>
        </div>
      </Popup>
    );
  },
});
